module.exports = __webpack_public_path__ + "img/homeb.5a701cc2.png";